"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _innerkenJsUtils = _interopRequireDefault(require("innerken-js-utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultDish = {
  // basicInfo*/
  note: '',
  apply: [],
  modShow: false,
  forceFormat: false
};

function formatApplyInfo(dish) {
  var _dish$apply, _dish$agName;

  var displayApply = [];

  if (!(dish.apply || dish.agName)) {
    return displayApply;
  }

  if ((dish === null || dish === void 0 ? void 0 : (_dish$apply = dish.apply) === null || _dish$apply === void 0 ? void 0 : _dish$apply.length) > 0) {
    dish.apply.forEach(mod => {
      var modInfo = dish.modInfo.find(i => i.id === mod.groupId);
      var groupName = modInfo.name;
      var item = [mod.selectId].flat().reduce((arr, id) => {
        if (!id) {
          return arr;
        }

        var index = modInfo.selectValue.indexOf(id);
        var value = "".concat(modInfo.selectName[index]);
        var priceInfo = modInfo.priceInfo[index];
        arr.push({
          groupName,
          value,
          priceInfo,
          hash: groupName + ':' + value + 'p' + priceInfo
        });
        return arr;
      }, []);
      displayApply = displayApply.concat(item);
    });
  } else if ((dish === null || dish === void 0 ? void 0 : (_dish$agName = dish.agName) === null || _dish$agName === void 0 ? void 0 : _dish$agName.length) > 0) {
    if (!dish.priceInfoTe) {
      dish.priceInfoTe = '';
    }

    [dish.agNameArr, dish.aNameArr, dish.priceInfoArr, dish.agIdArr, dish.aIdArr, dish.priceInfoTeArr] = [dish.agName, dish.aName, dish.priceInfo, dish.agId, dish.aId, dish.priceInfoTe].map(i => i.split(','));
    dish.agNameArr.forEach((ag, i) => {
      displayApply.push({
        agId: dish.agIdArr[i],
        aId: dish.aIdArr[i],
        groupName: ag,
        value: dish.aNameArr[i],
        priceInfo: dish.priceInfoArr[i],
        priceInfoTe: dish.priceInfoTeArr[i],
        hash: ag + ':' + dish.aNameArr[i] + 'p' + dish.priceInfoArr[i] + 'g' + dish.agIdArr[i]
      });
    });
  }

  return displayApply;
}

function getAddPrice(dish) {
  var price = 0;
  dish.displayApply.forEach(ap => {
    var _ap$priceInfo;

    price += parseFloat((_ap$priceInfo = ap.priceInfo) !== null && _ap$priceInfo !== void 0 ? _ap$priceInfo : 0);
  });
  return price;
}

function getAddPriceTe(dish) {
  var price = 0;
  dish.displayApply.forEach(ap => {
    var _ap$priceInfoTe;

    price += parseFloat((_ap$priceInfoTe = ap.priceInfoTe) !== null && _ap$priceInfoTe !== void 0 ? _ap$priceInfoTe : 0);
  });
  return price;
}

function buildApplyString(applyArr) {
  return applyArr.reduce((arr, i) => {
    arr.push(i.hash);
    return arr;
  }, []).join('/');
}

function dishIdentity(code, apply, note, tempDiscountStr, price, currentName, overrideConsumeTypeId, sourceMark, dishStatus) {
  var uid = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  return code + '&' + buildApplyString(apply) + '-&-' + note + '-&-' + tempDiscountStr + '-&-' + price + '-&' + currentName + '-&' + overrideConsumeTypeId + '-&' + sourceMark + '-&' + dishStatus + '-&' + uid;
}

function processApplyInfo(dish) {
  var _dish$note, _ref, _dish$originPrice, _ref2, _dish$originPriceTe, _dish$tempDiscountMod, _dish$tempDiscountMod2, _dish$price, _dish$currentName, _dish$overrideConsume, _dish$sourceMark, _dish$dishStatus, _dish$uid;

  dish.note = (_dish$note = dish.note) !== null && _dish$note !== void 0 ? _dish$note : '';
  dish.displayApply = formatApplyInfo(dish);
  dish.addPrice = getAddPrice(dish);
  dish.addPriceTe = getAddPriceTe(dish);
  dish.originPrice = parseFloat(parseFloat(dish.price) === 0 ? 0 : (_ref = (_dish$originPrice = dish.originPrice) !== null && _dish$originPrice !== void 0 ? _dish$originPrice : dish.price) !== null && _ref !== void 0 ? _ref : 0);
  dish.originPriceTe = parseFloat(parseFloat(dish.priceTe) === 0 ? 0 : (_ref2 = (_dish$originPriceTe = dish.originPriceTe) !== null && _dish$originPriceTe !== void 0 ? _dish$originPriceTe : dish.priceTe) !== null && _ref2 !== void 0 ? _ref2 : 0);
  dish.realPrice = parseFloat(dish.originPrice) + parseFloat(dish.addPrice) + parseFloat((_dish$tempDiscountMod = dish.tempDiscountMod) !== null && _dish$tempDiscountMod !== void 0 ? _dish$tempDiscountMod : 0);
  dish.realPriceTe = parseFloat(dish.originPriceTe) + parseFloat(dish.addPriceTe) + parseFloat((_dish$tempDiscountMod2 = dish.tempDiscountMod) !== null && _dish$tempDiscountMod2 !== void 0 ? _dish$tempDiscountMod2 : 0);

  if (dish.code.includes('ea')) {
    var _dish$tempDiscountMod3;

    if (dish.tid) {
      dish.price = dish.price - dish.addPrice;
      dish.originPrice = dish.price;
      dish.tid = null;
    }

    dish.realPrice = dish.originPrice + dish.addPrice + parseFloat((_dish$tempDiscountMod3 = dish.tempDiscountMod) !== null && _dish$tempDiscountMod3 !== void 0 ? _dish$tempDiscountMod3 : 0);
  }

  dish.identity = dishIdentity(dish.code, dish.displayApply, dish.note, dish.tempDiscountStr, (_dish$price = dish.price) !== null && _dish$price !== void 0 ? _dish$price : dish.realPrice, (_dish$currentName = dish.currentName) !== null && _dish$currentName !== void 0 ? _dish$currentName : '', (_dish$overrideConsume = dish.overrideConsumeTypeId) !== null && _dish$overrideConsume !== void 0 ? _dish$overrideConsume : '', (_dish$sourceMark = dish.sourceMark) !== null && _dish$sourceMark !== void 0 ? _dish$sourceMark : '', (_dish$dishStatus = dish.dishStatus) !== null && _dish$dishStatus !== void 0 ? _dish$dishStatus : null, (_dish$uid = dish.uid) !== null && _dish$uid !== void 0 ? _dish$uid : null);
}

function calculatePriceWithDiscount(price, discountStr) {
  var {
    timesMod,
    minusMod
  } = calculateDiscountMod(discountStr);
  return parseFloat(price) * timesMod - minusMod;
}

function calculateDiscountPrice(price, discountStr) {
  var {
    timesMod,
    minusMod
  } = calculateDiscountMod(discountStr);
  return parseFloat(price) - (parseFloat(price) * timesMod - minusMod);
}

function calculateDiscountMod(discountStr) {
  var timesMod = 1;
  var minusMod = 0;
  var discountPattern = /^([0-9]+(\.[0-9]+)?)?((p)+([kg])?)?$/;

  var finish = () => {
    return {
      minusMod,
      timesMod
    };
  };

  if (!discountPattern.test(discountStr)) {
    return finish();
  }

  if (discountStr.endsWith('p')) {
    timesMod = 1 - parseFloat(discountStr.slice(0, -1)) * 0.01;
  } else {
    minusMod = parseFloat(discountStr);
  }

  return finish();
}

function StandardDishesListFactory() {
  var list = [];
  var dishDictionary = {}; // code as key

  var orderDictionary = {}; // identity as key

  var counter = 0;

  var addDishToList = function addDishToList(dish, count) {
    var newDish = _innerkenJsUtils.default.deepCopy(dish);

    newDish.count = count !== null && count !== void 0 ? count : dish.count;
    newDish.sumCount = newDish.count;
    newDish.hash = counter;
    newDish.dodIds = [dish.dodId];
    processApplyInfo(newDish);
    counter++;
    orderDictionary[newDish.identity] = newDish;

    newDish.change = function (count) {
      changeNumber(newDish, count);
    };

    list.push(newDish);
  };

  function setDishList() {
    var dishList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if ((dishList === null || dishList === void 0 ? void 0 : dishList.length) > 0) {
      Object.assign(dishDictionary, dishList.reduce((obj, i) => {
        obj[i.code] = i;
        return obj;
      }, {}));
    }
  }

  function preProcessDishNoCopy(rawDish) {
    return preProcessDish(rawDish, false);
  }

  function preProcessDish(rawDish) {
    var _ref3, _dish$count, _ref4, _ref5, _dish$name;

    var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var dish = copy ? _innerkenJsUtils.default.deepCopy(rawDish) : rawDish;
    dish.count = parseInt((_ref3 = (_dish$count = dish.count) !== null && _dish$count !== void 0 ? _dish$count : dish.sumCount) !== null && _ref3 !== void 0 ? _ref3 : 0);
    dish.name = (_ref4 = (_ref5 = (_dish$name = dish.name) !== null && _dish$name !== void 0 ? _dish$name : dish.dishName) !== null && _ref5 !== void 0 ? _ref5 : dish._langsname) !== null && _ref4 !== void 0 ? _ref4 : dish.currentName;

    if (dish.code.toLowerCase().includes('ea')) {
      dish.name = dish.currentName;
    }

    processApplyInfo(dish);
    dish.wellFormat = true;
    return Object.assign({}, defaultDish, dish);
  }

  function getDishList() {
    return Object.keys(dishDictionary).reduce((arr, k) => {
      arr.push(dishDictionary[k]);
      return arr;
    }, []);
  }

  var changeNumber = function changeNumber(dish, count) {
    var dicDish = dishDictionary[dish.code];

    if (dicDish) {
      if (parseInt(dicDish.count) + parseInt(count) > 0) {
        dicDish.count += count;
      } else {
        dicDish.count = 0;
      }
    }

    if (!dish.wellFormat || dish.forceFormat) {
      dish.forceFormat = false;
      dish = preProcessDish(dish);
    }

    var listDish = orderDictionary[dish.identity];

    if (listDish) {
      // we found a dish in the list
      if (listDish.count + count > 0) {
        listDish.count += count;
        listDish.sumCount = listDish.count;
      } else {
        list.splice(list.indexOf(listDish), 1);
        delete orderDictionary[dish.identity];
      }

      if (count > 0) {
        listDish.dodIds.push(dish.dodId);
      } else {
        listDish.dodIds.pop(dish.dodId);
      }
    } else {
      // we found no dish in the list
      if (count >= 0 || dish.count >= 0) {
        addDishToList(dish, count);
      }
    }
  };

  var formatList = function formatList(list) {
    return list.map(preProcessDishNoCopy);
  };

  var add = function add(dish, count) {
    changeNumber(dish, count);
  };

  var remove = function remove(dish, count) {
    changeNumber(dish, count);
  };

  var total = function total() {
    return list.reduce((t, d) => {
      return t + parseFloat(d.realPrice * d.count);
    }, 0);
  };

  var count = function count() {
    return parseInt(list.reduce((t, d) => {
      return t + parseInt(d.count);
    }, 0));
  };

  var loadTTDishList = function loadTTDishList(ttDishList) {
    loadList(ttDishList);
  };

  var loadList = function loadList(_list) {
    clear();

    for (var d of _list) {
      add(d);
    }
  };

  var clear = function clear() {
    for (var k of Object.keys(dishDictionary)) {
      dishDictionary[k].count = 0;
    }

    for (var _k of Object.keys(orderDictionary)) {
      delete orderDictionary[_k];
    }

    list.splice(0, list.length);
  };

  return {
    orderDictionary,
    setDishList,
    dishDictionary,
    list,
    getDishList,
    add,
    remove,
    total,
    count,
    loadTTDishList,
    formatList,
    loadList,
    clear
  };
}

var _default = {
  StandardDishesListFactory,
  calculateDiscountMod,
  calculateDiscountPrice,
  calculatePriceWithDiscount
};
exports.default = _default;